import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export const EscolherCliente = ({ pedidoId, atual, onDone }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return undefined; }
    const t = setTimeout(() => { api.get("/clientes", { params: { q } }).then((r) => setRes(r.data.slice(0, 8))); }, 250);
    return () => { clearTimeout(t); };
  }, [q]);

  const ligar = async (cid) => {
    try {
      await api.put(`/atendimentos/${pedidoId}/cliente`, { cliente_id: cid });
      toast.success("Cliente associado ao pedido."); setQ(""); onDone();
    } catch (err) { toast.error(apiError(err)); }
  };
  const criar = async () => {
    try {
      const { data } = await api.post("/clientes", { nome: q.trim() });
      await ligar(data.id);
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div data-testid="escolher-cliente">
      <label className="text-[11px] text-slate-500">{atual ? "Trocar para outro cliente" : "Associar cliente (procure pelo nome, NIF ou telefone)"}</label>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Escreva pelo menos 2 letras…" data-testid="escolher-cliente-input" />
      {q.trim().length >= 2 && (
        <div className="mt-1 border border-slate-200 rounded-md divide-y max-h-56 overflow-y-auto">
          {res.map((c) => (
            <button key={c.id} type="button" onClick={() => ligar(c.id)} data-testid={`escolher-cliente-${c.id}`}
              className="w-full text-left text-xs px-2 py-1.5 hover:bg-sky-50">
              <b>{c.nome}</b>{c.nif ? ` · NIF ${c.nif}` : ""}{c.telefone ? ` · ${c.telefone}` : ""}
            </button>
          ))}
          <button type="button" onClick={criar} data-testid="escolher-cliente-criar" className="w-full text-left text-xs px-2 py-1.5 text-sky-700 hover:bg-sky-50">
            + Criar cliente novo "{q.trim()}"
          </button>
        </div>
      )}
    </div>
  );
};
